var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs as MuiBreadcrumbs, useMediaQuery } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Chip from '@mui/material/Chip';
import { ThemeProvider } from "@mui/material/styles";
import theme from '../theme';
var Breadcrumb = function (props) {
    return (_jsx(Chip, { sx: props.sx, label: props.label, title: props.label, className: props.className, clickable: props.clickable, onClick: props.onClick }));
};
var Breadcrumbs = function (props) {
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var components = __assign({ breadcrumb: Breadcrumb }, props.components);
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(MuiBreadcrumbs, __assign({ separator: _jsx(NavigateNextIcon, { fontSize: "small" }), maxItems: isMobile ? 2 : 8, sx: {
                p: isMobile ? '10px' : '20px',
                maxWidth: '100vw',
                '& .MuiBreadcrumbs-ol': {
                    overflow: 'auto',
                    flexWrap: 'nowrap'
                },
                '& .MuiChip-label': { flex: 1 }
            } }, { children: props.links.map(function (link, i) { return (_jsx(components.breadcrumb, { url: link.url, sx: i === props.links.length - 1 ? { borderRadius: "60px", backgroundColor: 'inherit', height: "38px", maxWidth: "250px" } : { borderRadius: "60px", height: "38px", maxWidth: "250px" }, label: link.text, title: link.text, icon: link.imageURL, className: link.linkClass, clickable: true, onClick: function () { window.location.href = link.url; } }, i)); }) })) })));
};
export { Breadcrumbs, Breadcrumb };
